<script>
import { cn } from "$lib/utils";

let className = "";
export { className as class };
const _class = cn("size-4", "shrink-0", className);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="1.4"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={_class}
  aria-label="X"
  {...$$restProps}><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg
>
